import { getPrefixedVar } from '@private/payment';
import styled, { css } from 'styled-components';

import { ICONS_MAP } from 'constants/icons';

export const Container = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  column-gap: 10px;
  color: ${getPrefixedVar(['header', 'downloads', 'icon'])};
  cursor: pointer;

  &:hover {
    color: ${getPrefixedVar(['header', 'downloads', 'hover', 'icon'])};
  }
`;

export const IconWrapper = styled.div<{
  $displayDot: boolean;
}>`
  position: relative;

  ${({ $displayDot }) => {
    if ($displayDot) {
      return css`
        &::after {
          content: '';
          position: absolute;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          top: 0;
          right: 0;
          background-color: ${getPrefixedVar(['header', 'downloads', 'iconDot'])};
        }
      `;
    }
  }}
`;

export const DownloadsIcon = styled(ICONS_MAP.Downloads)`
  transition: color 0.3s ease;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 100px;
`;
